import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { setInfo } from '../../actions/info'
import { withRouter } from 'react-router-dom'
import withPortalId from './withPortalId'
import { setPortal } from '../../actions/portal';

export const withAppRouterHandler = Component =>
  compose(withPortalId, withRouter, connect(null, { setPortal, setInfo }))(
    class AppRouterHandler extends React.Component {
      redirectToMenuPage = () => {
        this.props.history.replace({
          pathname: `/${this.portalId()}/menu`,
        })
      }

      redirectToSigninPage = () => {
        this.props.history.replace({
          pathname: `/${this.portalId()}/signin`,
        })
        this.props.setPortal({})
        this.props.setInfo('passcode', undefined)
      }

      portalId = () => this.props.match.params.portalId

      render() {
        return (
          <Component
            {...this.props}
            redirectToMenuPage={this.redirectToMenuPage}
            redirectToSigninPage={this.redirectToSigninPage}
          />
        )
      }
    },
  )

export const withPortalIdByRoute = Component =>
  compose(
    withPortalId,
    connect(null, { setInfo }),
    withRouter,
    withAppRouterHandler,
  )(
    class PortalIdByRoute extends React.Component {
      componentDidMount() {
        this.props.setInfo('portalId', this.portalIdByRoute())
      }

      portalIdByRoute = () => this.props.match.params.portalId

      render() {
        return (
          <Component {...this.props} portalIdByRoute={this.portalIdByRoute()} />
        )
      }
    },
  )



// WEBPACK FOOTER //
// ./src/modules/portal/withPortalIdByRoute.js